<template>
  <ol class="w-full list-none p-none mt-xs">
    <SelectableListItemSkeleton
      v-if="loading"
      v-for="(skeleton) in skeletonArray"
      :key="skeleton.id"
      class="bg-whiteOverride odd:bg-offWhite"
      data-test="skeletons"
    />
    <SelectableListItem
      v-if="!loading"
      v-for="(item, index) in list"
      v-on="$listeners"
      :class="index % 2 === 0 ? 'bg-whiteOverride' : 'bg-offWhite'"
      :key="item.id"
      :id="item.id"
      :title="item.title"
      :selected="item.selected"
      :secondaryInfo="item.secondaryInfo"
      :itemType="itemType"
      :aria-setsize="size"
      :ec="ec"
      :data-test="`list-item-${item.id}`"
    />
  </ol>
</template>

<script>
import { defineComponent } from 'vue';

import { SelectableListItem } from '@/components/library/lists/viewSwitcherList/SelectableListItem';
import SelectableListItemSkeleton from '@/components/library/lists/viewSwitcherList/SelectableListItem/SelectableListItemSkeleton.vue';

export default defineComponent({
  components: { SelectableListItemSkeleton, SelectableListItem },
  data() {
    return {
      skeletonArray: Array.from({ length: 5 }, (_, index) => ({ id: index })),
    };
  },
  props: {
    list: Array,
    size: Number,
    ec: String,
    itemType: String,
    loading: Boolean,
  },
});
</script>
